<span class="application-pill-wrapper">
  <span
    class="application-pill"
    [ngClass]="{
      'short-label': useShortLabel,
      'pill-header': isHeader,
    }"
    [ngStyle]="{
      backgroundColor: type.backgroundColor,
      color: type.textColor,
      borderColor: type.borderColor || type.backgroundColor,
    }"
  >
    {{ useShortLabel ? type.shortLabel : type.label }}
  </span>
</span>
